import { Button, Modal, Radio } from 'antd';
import { memo, useCallback, useContext, useState } from 'react';
import { ConversationContext } from '../../contexts/ConversationContext';
import { COLOR } from '../../utils/constants';

const ChangeColorModal = ({
  changeColorModal,
  closeChangeColorModal,
  conversationDetail,
}) => {
  const {
    conversationState: { conversation },
    updateConversation,
  } = useContext(ConversationContext);
  const [color, setColor] = useState(conversationDetail?.color || 'BLUE');

  const closeModal = useCallback(() => {
    closeChangeColorModal();
  }, [closeChangeColorModal]);

  const handleChangeRadioButton = useCallback((e) => {
    setColor(e.target.value);
  }, []);

  const submitColor = useCallback(() => {
    updateConversation(conversation?.items[0].conversationId, { color });
    closeModal();
  }, [closeModal, color, conversation?.items, updateConversation]);

  return (
    <Modal
      open={changeColorModal}
      title="Change color conversation"
      afterClose={closeModal}
      onCancel={closeModal}
      footer={[
        <Button type="primary" key="add" onClick={submitColor}>
          OK
        </Button>,
        <Button key="back" onClick={closeModal}>
          Close
        </Button>,
      ]}
      centered
      bodyStyle={{ textAlign: 'center' }}
    >
      <Radio.Group
        defaultValue={color}
        buttonStyle="solid"
        size="large"
        onChange={handleChangeRadioButton}
      >
        <Radio.Button
          value="RED"
          danger
          style={
            color === 'RED'
              ? { backgroundColor: COLOR.RED, borderColor: COLOR.RED }
              : null
          }
        >
          Red
        </Radio.Button>
        <Radio.Button
          value="GREEN"
          style={
            color === 'GREEN'
              ? { backgroundColor: COLOR.GREEN, borderColor: COLOR.GREEN }
              : null
          }
        >
          Green
        </Radio.Button>
        <Radio.Button
          value="BLUE"
          style={
            color === 'BLUE'
              ? { backgroundColor: COLOR.BLUE, borderColor: COLOR.BLUE }
              : null
          }
        >
          Blue
        </Radio.Button>
      </Radio.Group>
    </Modal>
  );
};

export default memo(ChangeColorModal);
